import ImageBox from '../imageBox/index.jsx'
import Text from '../text/index.jsx'
import SetColor from '../setColor/index.jsx'
import Radio from '../radio/index.jsx'
import Checkbok from '../checkbox/index.jsx'
import CheckboxItem from '../checkbox/item.jsx'
import Selector from '../selector/index.jsx'
import './side.less'
import { useState } from 'react'
import OfficialAccount from './officialAccount.jsx'
import React from 'react'
console.log(React)
export default function SuspensionSide(props) {
  const [ifon, setIfon] = useState({
    space: '1',
    isOpen: false,
    opents: [{ id: 1, text: '一键拨号' }, { id: 2, text: '进入小程序' }, { id: 3, text: '下载应用' }, { id: 4, text: '跳转链接' }, { id: 5, text: '进入小游戏' }, { id: 6, text: '枫页推广页' }, { id: 7, text: '一键拨号' }, { id: 8, text: '添加商家微信' }, { id: 9, text: '在线咨询' }, { id: 10, text: '关注公众号', tx: 'officialAccount' }]
  })

  const typeItem = props.ifon.myType[ifon.opents[props.ifon.type].tx]

  return (<div className='suspensionSide'>
    {!ifon.isOpen && <div className='suspensionSide_main1'>
      <div className='main1_no1'>
        <h3 className='no1_title'>悬浮按钮</h3>
        <span className='no1_tips1'>页面中出现全景图，将暂时消失。</span>
        <div className='no1_tips2'>支持腾讯广告全广告位</div>
      </div>

      <div className='main1_no2'>
        <h3 className='no2_title'>
          卡片设置
        </h3>
        <div className='no2_main'>
          <div className='main_item'>
            <span className='item_title'>转化按钮</span>
            <div className='item_main'>
              <span className='main_text'>一键拨号</span>
              <button className='main_button' onClick={() => {
                setIfon({
                  ...ifon,
                  isOpen: true
                })
              }}>设置</button>
            </div>
          </div>

          <div className='main_item'>
            <span className='item_title'>卡片样式</span>
            <div className='styleItem_main'>

              <div className={`styleMain_item ${props.ifon.style_type === 0 ? 'active' : ''}`} onClick={() => {
                if (props.ifon.style_type !== 0) {
                  props.mySetIfon && props.mySetIfon({
                    ...props.ifon,
                    style_type: 0
                  })
                }
              }}>
                <div className='item'>
                  <div className='item_no1'></div>
                  <div className='item_no2'>
                    <span className='no2_im'></span>
                    <span className='no2_im1'></span>
                  </div>
                  <div className='item_no3'></div>
                </div>
              </div>

              <div className={`styleMain_item ${props.ifon.style_type === 1 ? 'active' : ''}`} onClick={() => {
                if (props.ifon.style_type !== 1) {
                  props.mySetIfon && props.mySetIfon({
                    ...props.ifon,
                    style_type: 1
                  })
                }
              }}>
                <div className='item'>

                  <div className='item_no2'>
                    <span className='no2_im'></span>
                    <span className='no2_im1'></span>
                  </div>
                  <div className='item_no3'></div>
                </div>
              </div>

              <div className={`styleMain_item ${props.ifon.style_type === 2 ? 'active' : ''}`} onClick={() => {
                if (props.ifon.style_type !== 2) {
                  props.mySetIfon && props.mySetIfon({
                    ...props.ifon,
                    style_type: 2
                  })
                }
              }}>
                <div className='item'>

                  <div className='item_no2'>
                    <span className='no2_im'></span>

                  </div>
                  <div className='item_no3'></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className='main1_no3'>
        <h3 className='no3_title'>内容设置</h3>
        <div className='no3_main'>
          { props.ifon.style_type === 0 && <div className='main_item'>
            <span className='item_title'>图片</span>
            <div className='boxItem'>
              <ImageBox src={props.ifon.imageIfon.path} change={props.hoistPopup} mySwitch={props.hoistPopup}></ImageBox>
              <p className='boxItem_p'>图片大小：96×96像素<br />图片格式：不超过300KB，不支持Gif</p>
            </div>
          </div>}

          { ((props.ifon.style_type === 0) || (props.ifon.style_type === 1)) && <div className='main_item'>
            <span className='item_title'>标题</span>
            <Text text={props.ifon.title} setText={(value) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                title: value
              })
            }}></Text>
          </div>}

          <div className='main_item'>
            <span className='item_title'>描述</span>
            <Text text={props.ifon.desc} setText={(value) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                desc: value
              })
            }}></Text>
          </div>

          { ((props.ifon.style_type === 0) || (props.ifon.style_type === 1)) && <div className='main_item'>
            <span className='item_title'>标题字色</span>
            <SetColor color={props.ifon.title_color} setColor={(colorObj) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                title_color: colorObj.hex
              })
            }}></SetColor>
          </div>}

          <div className='main_item'>
            <span className='item_title'>描述字色</span>
            <SetColor color={props.ifon.desc_color} setColor={(colorObj) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                desc_color: colorObj.hex
              })
            }}></SetColor>
          </div>
        </div>
      </div>

      <div className='main1_no4'>
        <h3 className='no4_title'>更多设置</h3>
        <p className='no4_tips'>如果落地页只有一页，悬浮组件的更多设置必须为“进入页面时出现”、且“不消失”</p>
        <div className='no4_main'>

          <div className='main_item'>
            <span className='item_title'>出现方式</span>
            <div className='item_main'>
              <div className='myItem'>
                <Radio radio={props.ifon.appear_type} label={0} change={() => {
                  if (props.ifon.appear_type !== 0) {
                    props.mySetIfon && props.mySetIfon({
                      ...props.ifon,
                      appear_type: 0
                    })
                  }
                }}>进入页面时出现</Radio>
              </div>
              <div className='myItem'>
                <Radio radio={props.ifon.appear_type} label={1} change={() => {
                  if (props.ifon.appear_type !== 1) {
                    props.mySetIfon && props.mySetIfon({
                      ...props.ifon,
                      appear_type: 1
                    })
                  }
                }}>滑动页面时出现</Radio>
              </div>
            </div>
          </div>

          <div className='main_item'>
            <span className='item_title'>消失的方式</span>
            <div className='item_main'>
              <div className='myItem'>
                <Radio radio={props.ifon.disappear_type} label={0} change={() => {
                  if (props.ifon.disappear_type !== 0) {
                    props.mySetIfon && props.mySetIfon({
                      ...props.ifon,
                      disappear_type: 0
                    })
                  }
                }}>不消失</Radio>
              </div>
              <div className='myItem'>
                <Radio radio={props.ifon.disappear_type} label={1} change={() => {
                  if (props.ifon.disappear_type !== 1) {
                    props.mySetIfon && props.mySetIfon({
                      ...props.ifon,
                      disappear_type: 1
                    })
                  }
                }}>滑至页面底部时消失</Radio>
              </div>
            </div>
          </div>

          <div className='main_item'>
            <span className='item_title'>固定页面不出现</span>
            <div className='item_main' style={{
              marginLeft: '10px'
            }}>
              <Checkbok list={props.ifon.forbid_page_list} change={(list) => {
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  forbid_page_list: list
                })
              }}>
                {props.components.map((item, index) => {
                  return (<CheckboxItem id={index + 1} key={index}>第{index + 1}页</CheckboxItem>)
                })}
              </Checkbok>
            </div>
          </div>
        </div>
      </div>
    </div>}

    <div className={`suspensionSide_main2 ${ifon.isOpen ? 'open' : ''}`}>
      <div className='main2_no1'>
        <button className='no1_button' onClick={() => {
          setIfon({
            ...ifon,
            isOpen: false
          })
        }}>
          <i className='button_icon'>
            <svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='arrow-back'><path d='M9.15411 4.75496C9.34899 4.56009 9.34943 4.24426 9.15509 4.04884L8.8051 3.6969C8.61007 3.50078 8.29286 3.50026 8.09719 3.69574L3.14601 8.64209C3.04692 8.74108 2.99805 8.87131 2.99942 9.0011C2.99806 9.1309 3.04692 9.26112 3.14601 9.36011L8.09719 14.3065C8.29286 14.5019 8.61007 14.5014 8.8051 14.3053L9.15509 13.9534C9.34943 13.7579 9.34899 13.4421 9.15411 13.2472L5.65688 9.75001H14.5C14.7761 9.75001 15 9.52615 15 9.25001V8.75001C15 8.47387 14.7761 8.25001 14.5 8.25001H5.65907L9.15411 4.75496Z' fill-rule='evenodd'></path></svg>
          </i>
          <span className='button_text'>返回</span>
        </button>
      </div>

      <div className='main2_no2'>
        <h3 className='no2_title'>按钮类型</h3>
        <div className='no2_main'>
          <div className='main_box'>
            <Selector disables={[1, 2, 3, 4, 5, 6, 7, 8, 9]} options={ifon.opents} activeId={props.ifon.type + 1} change={(item) => {
              console.log(item)
            }}></Selector>
          </div>
        </div>
      </div>

      { ifon.opents[props.ifon.type].tx === 'officialAccount' && <OfficialAccount typeItem={typeItem} mySetIfon={(obj) => {
        props.mySetIfon && props.mySetIfon({
          ...props.ifon,
          myType: {
            ...props.ifon.myType,
            [ifon.opents[props.ifon.type].tx]: {
              ...obj
            }
          }
        })
      }}></OfficialAccount>}

    </div>
  </div >)
}
